<div *ngIf="createForm">

  <div class="container-fluid" [hidden]="indexPage < 1 || indexPage > 7">
    <div class="row">

      <div class="col-md-9">
        <div class="sticky-top fixedtop" *ngFor="let page of pages; let i = index">
          <div id="step{{ i+1 }}" *ngIf="indexPage === (i+1) && getIsCheckValid(indexPage)">
            <app-form-errors
              [stepid]="'_STEP_ID_' + (i+1)"
              [linkForRouter]="linkForRouter"
            >
            </app-form-errors>
          </div>
        </div>

        <div [class]="formClass">
          <fieldset>
            <legend *ngIf="indexPage > 0 && indexPage < 7">{{ getIntitule(indexPage) | translate }}</legend>

            <!-- Références de l'avis initial -->
            <app-step1 *ngIf="indexPage === 1" [uid]="getUid(1)" [parentForm]="form" [disabled]="disabled"
              [avisInitial]="ann.divers?.attribution?.avisInitial"
              [linkForRouter]="linkForRouter">
            </app-step1>

            <!-- Bloc 2. Attribution du marché -->
            <app-step2 *ngIf="indexPage === 2" [uid]="getUid(2)" [parentForm]="form" [disabled]="disabled"
              [attribution]="ann.divers?.attribution" [linkForRouter]="linkForRouter">
            </app-step2>

            <!-- Bloc 3. Identification de l’organisme qui passe le marché -->
            <app-step1common *ngIf="indexPage === 3" [uid]="getUidCommon(3)" [parentForm]="form" [disabled]="disabled" [divers]="ann.divers"
               [linkForRouter]="linkForRouter" [formName]="formName">
            </app-step1common>

            <!-- Bloc 4. Titulaire du marché : cas où radio bouton attribué à une unique personne est coché dans le bloc 2 -->
            <app-step4 *ngIf="indexPage === 4" [uid]="getUid(4)" [parentForm]="form" [disabled]="disabled"
              [attribution]="ann.divers?.attribution.attribution"
              [attribue]="ann?.divers?.attribution?.attribution?.resultat?.attribue"
              [linkForRouter]="linkForRouter">
            </app-step4>

            <!-- Bloc 5. Attribution des lots : cas où radio bouton attribué par lot ou comportant des lots infructueux est coché dans le bloc 2 -->
            <app-step5 *ngIf="indexPage === 5" [uid]="getUid(5)" [parentForm]="form" [disabled]="disabled"
              [attribution]="ann.divers?.attribution.attribution"
              [linkForRouter]="linkForRouter">
            </app-step5>

            <!-- Bloc 6. Autres renseignements  -->
            <app-step6 *ngIf="indexPage === 6" [uid]="getUid(6)" [parentForm]="form" [disabled]="disabled"
              [typeAnn_DIVER_G2]="ann.divers?.attribution" [linkForRouter]="linkForRouter">
            </app-step6>
          </fieldset>
        </div>
      </div>
    </div>
  </div>
</div>
